import React, { useReducer, useEffect } from "react";
import PolicyContext from "./PolicyContext";
import PolicyReducer from "./PolicyReducer";

const PolicyStore = (props: any) => {
  const initialState = {
    selectedPolicy: [],
    previewPolicy: {},
  };

  const [state, dispatch] = useReducer(PolicyReducer, initialState);

  const setSelectedPolicy = (policy: any) => {
    dispatch({
      type: "SELECTED_POLICY",
      payload: policy,
    });
  };

  const setPreviewPolicyRecord = (policy: any) => {
    dispatch({
      type: "PREVIEW_POLICY",
      payload: policy,
    });
  };

  return (
    <PolicyContext.Provider
      value={{
        ...state,
        setSelectedPolicy,
        setPreviewPolicyRecord,
      }}
    >
      {props.children}
    </PolicyContext.Provider>
  );
};

export default PolicyStore;
